class DynamicHeight {
	constructor(config) {
		this.config = Object.assign({
			scope: '',
			name: '',
			wrappers: ['body'],
			callback: null
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.setHeight();
		this.addEventlisteners();
	}

	addEventlisteners() {
		let observer = new ResizeObserver(this.setHeight.bind(this));
		observer.observe(this.$scope[0]);
	}

	setHeight() {
		this.timeout ? clearTimeout(this.timeout) : null;
		this.timeout = setTimeout(() => {
			let height = this.$scope.outerHeight();
			for(let key in this.config.wrappers) {
				$(this.config.wrappers[key]).css(`--${this.config.name}`, height + 'px');
				if(this.config.callback) {
					this.config.callback();
				}
			}
		}, 200);
	}
}

export default DynamicHeight;
